module.exports = __webpack_public_path__ + "img/star-4.b636858c.svg";